import { render, staticRenderFns } from "./SectionItems.vue?vue&type=template&id=440a1f19&"
import script from "./SectionItems.vue?vue&type=script&lang=js&"
export * from "./SectionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports